import React from "react";
import { Modal } from "react-bootstrap";
import { logHourFormatTime } from "../../../constants/date";

interface SpouseLoggedHourModalProps {
  show: boolean;
  onHide: () => void;
  data?: any
}

const SpouseLoggedHourModal: React.FC<SpouseLoggedHourModalProps> = ({ show, onHide, data }) => {

  const logHourTime = logHourFormatTime({ hours: data?.hours, minutes: data?.minutes });


  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Spouse Logged Hours</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {logHourTime ? (
          <div className="d-flex align-items-center justify-content-between border rounded p-3 bg-light">
            <div className="d-flex align-items-center gap-2">
              <img
                src={data?.spouse?.image ? `${data?.spouse?.image}` : "/assets/img/userCircle.png"}
                alt="Spouse"
                className="rounded-circle"
                width="40"
                height="40"
              />
              <span>{data?.spouse?.name}</span>
            </div>
            <span className="badge bg-warning text-dark">{logHourTime}</span>
          </div>

        ) : (
          <p className="text-center w-100 py-4">No log hours found.</p>
        )}

      </Modal.Body>
    </Modal>
  );
};

export default SpouseLoggedHourModal;